export const GET_TOC = 'get toc';

export const TOC_TOGGLE_CHAPTER = 'toc toggle chapter';

/* istanbul ignore next */
export function tocToggleChapter(id){
    return {
        type : TOC_TOGGLE_CHAPTER,
        id : id
    };
}

export const TOC_TOGGLE = 'toc toggle';

/* istanbul ignore next */
export function toggleTOC(){
    return {
        type: TOC_TOGGLE
    };
}



// WEBPACK FOOTER //
// ./src/actions/toc.action.js